import React from "react";
import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import Subheader from "react-md/lib/Subheaders";
import { map } from "lodash";
import {DebugElement} from "../Atollon/debug";

const ListComponent = ({ items, title, leftAvatar, rightIcon }) => {

    console.log( 'ListComponent', items );

        // <DebugElement text={"src/components/List.js"}/>
  return (
    <List className="md-paper--1">
      <Subheader primaryText={title} />
      {map(items, (item, i) => {

          console.log('ListComponent drawItem',i,item);

          return (
        <ListItem
          key={i}
          leftAvatar={leftAvatar}
          rightIcon={rightIcon}
          primaryText={item.primary}
          secondaryText={item.secondary}
          className="list"
          onClick={item.onClick}
        />
      )})}
    </List>
  );
};

export default ListComponent;



// WEBPACK FOOTER //
// ./src/components/List.js